/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';
	const _lang = location.pathname.split('/')[1];
	let _newscategoryNone = 'ニュースルーム非掲載';
	let _disclosure = '適時開示';
	if (_lang == 'en') {
		_newscategoryNone = 'Other';
		_disclosure = 'TSE Disclosures';
	}
	const slider = () => {
		if(document.querySelectorAll('.js-news-pickup').length) {
			const getJSONfilespickup = (_id) => {
				return `/${_lang}/ajax/news/tags/${_id}.json`;
			};
			const slidermatchHeight = () => {
				const $elements = document.querySelectorAll( '[data-mhsld]' );
				const groups = new Map();
	
				$elements.forEach( ele => { ele.style.height = 'auto'; } ); // 初期化
	
				$elements.forEach( ele => {
					const attributeName = ele.getAttribute( 'data-mhsld' );
					if ( !groups.has( attributeName ) ) {
						groups.set( attributeName, [] );
					}
					groups.get( attributeName ).push( ele );
				} );
				groups.forEach( group => {
					const attributeGroups = new Map();
					group.forEach( ele => {
						const attributeName = ele.getAttribute( 'data-mhsld' );
						const topPosition = ele.getBoundingClientRect().top;
						const key = attributeName + '_' + topPosition;
						if ( !attributeGroups.has( key ) ) {
							attributeGroups.set( key, [] );
						}
						attributeGroups.get( key ).push( ele );
					} );
					attributeGroups.forEach( (item) => {
						const maxHeight = Math.max( ...item.map( ele => ele.offsetHeight ) );
						item.forEach( (ele2) => {
							ele2.style.height = `${maxHeight}px`;
						});
					});
				} );
			};
			// 1件目以外remove
			document.querySelectorAll('.js-news-pickup .news-pick').forEach(function(val, index){
				if(!(index == 0)) {
					val.remove();
				}
			});
			fetch(getJSONfilespickup(document.querySelector('.js-news-pickup .js-news-pickup-id').textContent)).then(function (data) {
				return data.json();
			}).then(function (data) {
				let _tag = '';
				_tag += `<p class="news-slider-item-text-category _01">${data.rt_bn_news_category_tags[0].rt_cf_n_category_name.content[0]}</p>`;
				data.rt_bn_news_category_tags[0].cf_n_tags.forEach(function(tagval, tagindex){
					if(tagval.rt_cf_n_tags_label) {
						if(tagval.rt_cf_n_tags_label.content == _disclosure) {
							_tag += `<p class="news-slider-item-text-category _03">${_disclosure}</p>`;
						} else {
							_tag += `<p class="news-slider-item-text-category _02">${tagval.rt_cf_n_tags_label.content}</p>`;
						}
					}
				});
				document.querySelector('.js-news-pickup').querySelector('.news-slider-item-text-category-wrap').insertAdjacentHTML('beforeend', _tag);
			});
			document.querySelectorAll('.news-slider .news-slider-item').forEach(function(val, index){
				// 1件目のみremove
				if(index == 0) {
					val.remove();
				} else {
					fetch(getJSONfilespickup(val.querySelector('.js-news-pickup-id').textContent)).then(function (data) {
						return data.json();
					}).then(function (data) {
						// console.log(data,'data');
						let _tag = '';
						_tag += `<p class="news-slider-item-text-category _01">${data.rt_bn_news_category_tags[0].rt_cf_n_category_name.content[0]}</p>`;
						data.rt_bn_news_category_tags[0].cf_n_tags.forEach(function(tagval, tagindex){
							if(tagval.rt_cf_n_tags_label) {
								if(tagval.rt_cf_n_tags_label.content == _disclosure) {
									_tag += `<p class="news-slider-item-text-category _03">${_disclosure}</p>`;
								} else {
									_tag += `<p class="news-slider-item-text-category _02">${tagval.rt_cf_n_tags_label.content}</p>`;
								}
							}
						});
						val.querySelector('.news-slider-item-text-category-wrap').insertAdjacentHTML('beforeend', _tag);
						slidermatchHeight();
					});
				}
			});
			new Swiper('.news-slider', {
				slidesPerView: 1,
				spaceBetween: 0,
				// loop: true,
				// loopAdditionalSlides: 1,
				speed: 1000,
				autoplay: false,
				watchSlidesProgress: true,
				navigation: {
					nextEl: '.news-slider-control .swiper-button-next',
					prevEl: '.news-slider-control .swiper-button-prev',
				},
				breakpoints: {
				  1024: {
					slidesPerView: 3,
					spaceBetween: 40,
				  },
				},
			});
		}
	};
	const dropDown = () => {
		if(document.querySelector('.js-news-yearList')) {
			// 最新と最古の年を取得
			const latest = document.querySelector('.js-news-latest-year').textContent;
			const earliest = document.querySelector('.js-news-earliest-year').textContent;
			// ドロップダウンリスト要素を取得
			const yearList = document.querySelector('.js-news-yearList');
			const yearListSubmit = document.querySelector('.js-news-yearList-submit');
			const optionVal = (_num) => {
				if(location.pathname.replace('index.html','') == `/${_lang}/news/`) {
					return `/${_lang}/news/list/`+_num+`/`;
				} else {
					if(location.pathname.match(/\d{4}/)){
						// 文字列に正規表現4桁数値が含まれていたら
						return location.pathname.replace(location.pathname.match(/\d{4}/)[0], _num);
					}
				}
			};
			// 最新から最古の年までのオプションを生成し追加
			for(var i =latest; i>=earliest; i--) {
				const option = document.createElement('option');
				if(location.pathname.split('/')[1] == 'jp') {
					option.textContent = i.toString() + '年';
				} else {
					option.textContent = i.toString();
				}
				option.value = optionVal(i);
				document.querySelector('.js-news-yearList').appendChild(option);
			}
			// ドロップダウンリストで選択された年を設定
			if(!(location.pathname.replace('index.html','') == `/${_lang}/news/`)) {
				yearList.value = location.pathname;
			}
			// ドロップダウンリストの変更イベントを処理
			yearListSubmit.addEventListener('click', function () {
				location.href = yearList.value;
			});
		}
	};
	const newsList = () => {
		if(document.querySelectorAll('.js-newsList').length) {
			let _year = document.querySelector('.js-newsList-year').textContent;
			let _category = '';
			if(document.querySelectorAll('.js-newsList-category').length) {
				document.querySelectorAll('.js-newsList-category').forEach(function(val, index){
					if(val.textContent) {
						if(index == 0) {
							_category += '?p_category='+val.textContent;
						} else {
							_category += '&p_category='+val.textContent;
						}
					}
				});
			}
			// console.log(_category,'cate');
			const getJSONfiles = () => {
				if(location.pathname.split('/')[2] == 'ir') {
					return `/${_lang}/ir/ajax/news/${_year}/list.json${_category}`;
				} else if(location.pathname.split('/')[2] == 'sustainability') {
					if(!(location.pathname.split('/')[3] == 'employee')) {
						return `/${_lang}/ajax/sustainability/news/${_year}/list.json${_category}`;
					} else {
						return `/${_lang}/ajax/sustainability/employee/news/${_year}/list.json${_category}`;
					}
				} else if(location.pathname.split('/')[2] == 'recruit') {
					if(!(location.pathname.split('/')[3] == 'group_recruiting')) {
						return `/${_lang}/ajax/recruit/news/${_year}/list.json${_category}`;
					} else {
						return `/${_lang}/ajax/recruit/group_recruiting/news/${_year}/list.json${_category}`;
					}
				} else if(location.pathname.split('/')[2] == 'news') {
					if(location.pathname.split('/')[3] == 'group') {
						return `/${_lang}/ajax/news/group/${_year}/list.json${_category}`;
					} else if(location.pathname.split('/')[3] == 'human-resources') {
						return `/${_lang}/ajax/news/human-resources/${_year}/list.json${_category}`;
					} else if(location.pathname.split('/')[3] == 'nm') {
						return `/${_lang}/ajax/news/nm/${_year}/list.json${_category}`;
					} else if(location.pathname.split('/')[3] == 'nic') {
						return `/${_lang}/ajax/news/nic/${_year}/list.json${_category}`;
					} else {
						return `/${_lang}/ajax/news/list/${_year}/list.json${_category}`;
					}
				}
			};
			fetch(getJSONfiles()).then(function (data) {
				return data.json();
			}).then(function (data) {
				// console.log(data,'data');
				const bytesToSize = (bytes) => {
					var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
					if (bytes === 0) {
						return 'n/a';
					}
					var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
					if (i === 0) {
						return bytes + ' ' + sizes[i];
					}
					return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
				}
				// console.log(data,'tada');
				let HTML12 = '';
				let HTML11 = '';
				let HTML10 = '';
				let HTML09 = '';
				let HTML08 = '';
				let HTML07 = '';
				let HTML06 = '';
				let HTML05 = '';
				let HTML04 = '';
				let HTML03 = '';
				let HTML02 = '';
				let HTML01 = '';
				if(data.rt_bn_news.length) {
					data.rt_bn_news.forEach(function(val, index){
						let _link = '';
						if(!val.rt_cf_n_icon_blank) {
							if(!val.rt_cf_n_attachment_file_icon_pdf) {
								if(!val.rt_cf_n_href) {
									_link = `<div class="mod-newsList02-item-link" style="pointer-events:none;">
										<p>${val.rt_cf_n_title.content[0]}</span></p>
									</div>`;
								} else if(val.rt_cf_n_href.href == '#') {
									_link = `<div class="mod-newsList02-item-link" style="pointer-events:none;">
										<p>${val.rt_cf_n_title.content[0]}</span></p>
									</div>`;
								} else {
									if(val.rt_cf_n_href.target == '_blank') {
										_link = `<a href="${val.rt_cf_n_href.href}" target="_blank" class="mod-newsList02-item-link">
											<p>${val.rt_cf_n_title.content[0]}</p>
										</a>`;
									} else {
										_link = `<a href="${val.rt_cf_n_href.href}" class="mod-newsList02-item-link">
											<p>${val.rt_cf_n_title.content[0]}</p>
										</a>`;
									}
								}
							} else {
								_link = `<a href="${val.rt_cf_n_href.href}" target="_blank" class="mod-newsList02-item-link">
									<svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#pdf" /></svg>
									<p>${val.rt_cf_n_title.content[0]} [PDF:<span class="">${bytesToSize(val.rt_cf_n_attachment_file_size.content)}</span>]</p>
								</a>`;
							}
						} else {
							_link = `<a href="${val.rt_cf_n_href.href}" target="_blank" class="mod-newsList02-item-link">
								<p>${val.rt_cf_n_title.content[0]}<svg aria-hidden="true" class="rt_cf_n_icon_blank"><use xlink:href="/common/svg/sprite.svg#blank" /></svg></p>
							</a>`;
						}
						let _tag = '';
						if(document.querySelectorAll('.js-newsList-category-label-add').length) {
							if(!(document.querySelectorAll('.js-newsList-category').length == 1)) {
								// 一般人事（human-resources）では出さない
								if((val.rt_cf_n_category_name.content)) {
									if(!(val.rt_cf_n_category_name.content[0] == _newscategoryNone)) {
										if(!(location.pathname.split('/')[3] == 'human-resources')) {
											_tag += `<p class="mod-newsList02-item-category _01">${val.rt_cf_n_category_name.content[0]}</p>`;
										}
									}
								}
							}
						}
						if(val.cf_n_tags.length) {
							val.cf_n_tags.forEach(function(tagval, tagindex){
								if(tagval.rt_cf_n_tags_label) {
									if(tagval.rt_cf_n_tags_label.content == _disclosure) {
										_tag += `<p class="mod-newsList02-item-category _03">${_disclosure}</p>`;
									} else {
										_tag += `<p class="mod-newsList02-item-category _02">${tagval.rt_cf_n_tags_label.content}</p>`;
									}
								}
							});
						}
						let _html = '';
						_html = `<li class="mod-newsList02-item"><div class="mod-newsList02-item-inner">
								<p class="mod-newsList02-item-day ff_lato">${val.rt_cf_n_date.content}</p>
								<div class="mod-newsList02-item-category-wrap">
								${_tag}
								</div>
							</div>
							${_link}
						</div></li>`;
						if(val.month == '12') {
							HTML12 += _html;
						} else if(val.month == '11') {
							HTML11 += _html;
						} else if(val.month == '10') {
							HTML10 += _html;
						} else if(val.month == '09') {
							HTML09 += _html;
						} else if(val.month == '08') {
							HTML08 += _html;
						} else if(val.month == '07') {
							HTML07 += _html;
						} else if(val.month == '06') {
							HTML06 += _html;
						} else if(val.month == '05') {
							HTML05 += _html;
						} else if(val.month == '04') {
							HTML04 += _html;
						} else if(val.month == '03') {
							HTML03 += _html;
						} else if(val.month == '02') {
							HTML02 += _html;
						} else if(val.month == '01') {
							HTML01 += _html;
						}
				 	});
					 if(!HTML12) {
						document.querySelector('.js-newsList12-li').classList.add('di_none');
						document.querySelector('.js-newsList').querySelector('.js-newsList12').classList.add('di_none');
					 } else {
						document.querySelector('.js-newsList').querySelector('.js-newsList12').querySelector('.mod-newsList02').insertAdjacentHTML('beforeend', HTML12);
					 }
					 if(!HTML11) {
						document.querySelector('.js-newsList11-li').classList.add('di_none');
						 document.querySelector('.js-newsList').querySelector('.js-newsList11').classList.add('di_none');
					 } else {
						 document.querySelector('.js-newsList').querySelector('.js-newsList11').querySelector('.mod-newsList02').insertAdjacentHTML('beforeend', HTML11);
					 }
					 if(!HTML10) {
						document.querySelector('.js-newsList10-li').classList.add('di_none');
						 document.querySelector('.js-newsList').querySelector('.js-newsList10').classList.add('di_none');
					 } else {
						 document.querySelector('.js-newsList').querySelector('.js-newsList10').querySelector('.mod-newsList02').insertAdjacentHTML('beforeend', HTML10);
					 }
					 if(!HTML09) {
						document.querySelector('.js-newsList09-li').classList.add('di_none');
						 document.querySelector('.js-newsList').querySelector('.js-newsList09').classList.add('di_none');
					 } else {
						 document.querySelector('.js-newsList').querySelector('.js-newsList09').querySelector('.mod-newsList02').insertAdjacentHTML('beforeend', HTML09);
					 }
					 if(!HTML08) {
						document.querySelector('.js-newsList08-li').classList.add('di_none');
						 document.querySelector('.js-newsList').querySelector('.js-newsList08').classList.add('di_none');
					 } else {
						 document.querySelector('.js-newsList').querySelector('.js-newsList08').querySelector('.mod-newsList02').insertAdjacentHTML('beforeend', HTML08);
					 }
					 if(!HTML07) {
						document.querySelector('.js-newsList07-li').classList.add('di_none');
						 document.querySelector('.js-newsList').querySelector('.js-newsList07').classList.add('di_none');
					 } else {
						 document.querySelector('.js-newsList').querySelector('.js-newsList07').querySelector('.mod-newsList02').insertAdjacentHTML('beforeend', HTML07);
					 }
					 if(!HTML06) {
						document.querySelector('.js-newsList06-li').classList.add('di_none');
						 document.querySelector('.js-newsList').querySelector('.js-newsList06').classList.add('di_none');
					 } else {
						 document.querySelector('.js-newsList').querySelector('.js-newsList06').querySelector('.mod-newsList02').insertAdjacentHTML('beforeend', HTML06);
					 }
					 if(!HTML05) {
						document.querySelector('.js-newsList05-li').classList.add('di_none');
						 document.querySelector('.js-newsList').querySelector('.js-newsList05').classList.add('di_none');
					 } else {
						 document.querySelector('.js-newsList').querySelector('.js-newsList05').querySelector('.mod-newsList02').insertAdjacentHTML('beforeend', HTML05);
					 }
					 if(!HTML04) {
						document.querySelector('.js-newsList04-li').classList.add('di_none');
						 document.querySelector('.js-newsList').querySelector('.js-newsList04').classList.add('di_none');
					 } else {
						 document.querySelector('.js-newsList').querySelector('.js-newsList04').querySelector('.mod-newsList02').insertAdjacentHTML('beforeend', HTML04);
					 }
					 if(!HTML03) {
						document.querySelector('.js-newsList03-li').classList.add('di_none');
						 document.querySelector('.js-newsList').querySelector('.js-newsList03').classList.add('di_none');
					 } else {
						 document.querySelector('.js-newsList').querySelector('.js-newsList03').querySelector('.mod-newsList02').insertAdjacentHTML('beforeend', HTML03);
					 }
					 if(!HTML02) {
						document.querySelector('.js-newsList02-li').classList.add('di_none');
						 document.querySelector('.js-newsList').querySelector('.js-newsList02').classList.add('di_none');
					 } else {
						 document.querySelector('.js-newsList').querySelector('.js-newsList02').querySelector('.mod-newsList02').insertAdjacentHTML('beforeend', HTML02);
					 }
					 if(!HTML01) {
						document.querySelector('.js-newsList01-li').classList.add('di_none');
						 document.querySelector('.js-newsList').querySelector('.js-newsList01').classList.add('di_none');
					 } else {
						 document.querySelector('.js-newsList').querySelector('.js-newsList01').querySelector('.mod-newsList02').insertAdjacentHTML('beforeend', HTML01);
					 }
					 document.querySelector('.js-newsList').classList.remove('di_none');
				} else {
					document.querySelector('.js-newsList-nolist').classList.remove('di_none');
				}
			});
			if(document.querySelectorAll('.js-newsList_2').length) {
				const getJSONfilesGroupInformation = () => {
					return `/${_lang}/ajax/news/list/${_year}/list.json?p_category=group_information`;
				}
				fetch(getJSONfilesGroupInformation()).then(function (data) {
					return data.json();
				}).then(function (data) {
					const bytesToSize = (bytes) => {
						var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
						if (bytes === 0) {
							return 'n/a';
						}
						var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
						if (i === 0) {
							return bytes + ' ' + sizes[i];
						}
						return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
					}
					// console.log(data,'tada');
					let HTML12 = '';
					let HTML11 = '';
					let HTML10 = '';
					let HTML09 = '';
					let HTML08 = '';
					let HTML07 = '';
					let HTML06 = '';
					let HTML05 = '';
					let HTML04 = '';
					let HTML03 = '';
					let HTML02 = '';
					let HTML01 = '';
					if(data.rt_bn_news.length) {
						data.rt_bn_news.forEach(function(val, index){
							let _link = '';
							if(!val.rt_cf_n_icon_blank) {
								if(!val.rt_cf_n_attachment_file_icon_pdf) {
									if(!val.rt_cf_n_href) {
										_link = `<div class="mod-newsList02-item-link" style="pointer-events:none;">
											<p>${val.rt_cf_n_title.content[0]}</span></p>
										</div>`;
									} else if(val.rt_cf_n_href.href == '#') {
										_link = `<div class="mod-newsList02-item-link" style="pointer-events:none;">
											<p>${val.rt_cf_n_title.content[0]}</span></p>
										</div>`;
									} else {
										if(val.rt_cf_n_href.target == '_blank') {
											_link = `<a href="${val.rt_cf_n_href.href}" target="_blank" class="mod-newsList02-item-link">
												<p>${val.rt_cf_n_title.content[0]}</p>
											</a>`;
										} else {
											_link = `<a href="${val.rt_cf_n_href.href}" class="mod-newsList02-item-link">
												<p>${val.rt_cf_n_title.content[0]}</p>
											</a>`;
										}
									}
								} else {
									_link = `<a href="${val.rt_cf_n_href.href}" target="_blank" class="mod-newsList02-item-link">
										<svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#pdf" /></svg>
										<p>${val.rt_cf_n_title.content[0]} [PDF:<span class="">${bytesToSize(val.rt_cf_n_attachment_file_size.content)}</span>]</p>
									</a>`;
								}
							} else {
								_link = `<a href="${val.rt_cf_n_href.href}" target="_blank" class="mod-newsList02-item-link">
									<p>${val.rt_cf_n_title.content[0]}<svg aria-hidden="true" class="rt_cf_n_icon_blank"><use xlink:href="/common/svg/sprite.svg#blank" /></svg></p>
								</a>`;
							}
							let _tag = '';
							// if(!_category) {
							// 	if(!(val.rt_cf_n_category_name.content[0] == _newscategoryNone)) {
							// 		_tag += `<p class="mod-newsList02-item-category _01">${val.rt_cf_n_category_name.content[0]}</p>`;
							// 	}
							// }
							if(val.cf_n_tags.length) {
								val.cf_n_tags.forEach(function(tagval, tagindex){
									if(tagval.rt_cf_n_tags_label) {
										if(tagval.rt_cf_n_tags_label.content == _disclosure) {
											_tag += `<p class="mod-newsList02-item-category _03">${_disclosure}</p>`;
										} else {
											_tag += `<p class="mod-newsList02-item-category _02">${tagval.rt_cf_n_tags_label.content}</p>`;
										}
									}
								});
							}
							let _html = '';
							_html = `<li class="mod-newsList02-item"><div class="mod-newsList02-item-inner">
									<p class="mod-newsList02-item-day ff_lato">${val.rt_cf_n_date.content}</p>
									<div class="mod-newsList02-item-category-wrap">
									${_tag}
									</div>
								</div>
								${_link}
							</div></li>`;
							if(val.month == '12') {
								HTML12 += _html;
							} else if(val.month == '11') {
								HTML11 += _html;
							} else if(val.month == '10') {
								HTML10 += _html;
							} else if(val.month == '09') {
								HTML09 += _html;
							} else if(val.month == '08') {
								HTML08 += _html;
							} else if(val.month == '07') {
								HTML07 += _html;
							} else if(val.month == '06') {
								HTML06 += _html;
							} else if(val.month == '05') {
								HTML05 += _html;
							} else if(val.month == '04') {
								HTML04 += _html;
							} else if(val.month == '03') {
								HTML03 += _html;
							} else if(val.month == '02') {
								HTML02 += _html;
							} else if(val.month == '01') {
								HTML01 += _html;
							}
						 });
						 if(!HTML12) {
							document.querySelector('.js-newsList_2_12-li').classList.add('di_none');
							document.querySelector('.js-newsList_2').querySelector('.js-newsList_2_12').classList.add('di_none');
						 } else {
							document.querySelector('.js-newsList_2').querySelector('.js-newsList_2_12').querySelector('.mod-newsList02').insertAdjacentHTML('beforeend', HTML12);
						 }
						 if(!HTML11) {
							document.querySelector('.js-newsList_2_11-li').classList.add('di_none');
							 document.querySelector('.js-newsList_2').querySelector('.js-newsList_2_11').classList.add('di_none');
						 } else {
							 document.querySelector('.js-newsList_2').querySelector('.js-newsList_2_11').querySelector('.mod-newsList02').insertAdjacentHTML('beforeend', HTML11);
						 }
						 if(!HTML10) {
							document.querySelector('.js-newsList_2_10-li').classList.add('di_none');
							 document.querySelector('.js-newsList_2').querySelector('.js-newsList_2_10').classList.add('di_none');
						 } else {
							 document.querySelector('.js-newsList_2').querySelector('.js-newsList_2_10').querySelector('.mod-newsList02').insertAdjacentHTML('beforeend', HTML10);
						 }
						 if(!HTML09) {
							document.querySelector('.js-newsList_2_09-li').classList.add('di_none');
							 document.querySelector('.js-newsList_2').querySelector('.js-newsList_2_09').classList.add('di_none');
						 } else {
							 document.querySelector('.js-newsList_2').querySelector('.js-newsList_2_09').querySelector('.mod-newsList02').insertAdjacentHTML('beforeend', HTML09);
						 }
						 if(!HTML08) {
							document.querySelector('.js-newsList_2_08-li').classList.add('di_none');
							 document.querySelector('.js-newsList_2').querySelector('.js-newsList_2_08').classList.add('di_none');
						 } else {
							 document.querySelector('.js-newsList_2').querySelector('.js-newsList_2_08').querySelector('.mod-newsList02').insertAdjacentHTML('beforeend', HTML08);
						 }
						 if(!HTML07) {
							document.querySelector('.js-newsList_2_07-li').classList.add('di_none');
							 document.querySelector('.js-newsList_2').querySelector('.js-newsList_2_07').classList.add('di_none');
						 } else {
							 document.querySelector('.js-newsList_2').querySelector('.js-newsList_2_07').querySelector('.mod-newsList02').insertAdjacentHTML('beforeend', HTML07);
						 }
						 if(!HTML06) {
							document.querySelector('.js-newsList_2_06-li').classList.add('di_none');
							 document.querySelector('.js-newsList_2').querySelector('.js-newsList_2_06').classList.add('di_none');
						 } else {
							 document.querySelector('.js-newsList_2').querySelector('.js-newsList_2_06').querySelector('.mod-newsList02').insertAdjacentHTML('beforeend', HTML06);
						 }
						 if(!HTML05) {
							document.querySelector('.js-newsList_2_05-li').classList.add('di_none');
							 document.querySelector('.js-newsList_2').querySelector('.js-newsList_2_05').classList.add('di_none');
						 } else {
							 document.querySelector('.js-newsList_2').querySelector('.js-newsList_2_05').querySelector('.mod-newsList02').insertAdjacentHTML('beforeend', HTML05);
						 }
						 if(!HTML04) {
							document.querySelector('.js-newsList_2_04-li').classList.add('di_none');
							 document.querySelector('.js-newsList_2').querySelector('.js-newsList_2_04').classList.add('di_none');
						 } else {
							 document.querySelector('.js-newsList_2').querySelector('.js-newsList_2_04').querySelector('.mod-newsList02').insertAdjacentHTML('beforeend', HTML04);
						 }
						 if(!HTML03) {
							document.querySelector('.js-newsList_2_03-li').classList.add('di_none');
							 document.querySelector('.js-newsList_2').querySelector('.js-newsList_2_03').classList.add('di_none');
						 } else {
							 document.querySelector('.js-newsList_2').querySelector('.js-newsList_2_03').querySelector('.mod-newsList02').insertAdjacentHTML('beforeend', HTML03);
						 }
						 if(!HTML02) {
							document.querySelector('.js-newsList_2_02-li').classList.add('di_none');
							 document.querySelector('.js-newsList_2').querySelector('.js-newsList_2_02').classList.add('di_none');
						 } else {
							 document.querySelector('.js-newsList_2').querySelector('.js-newsList_2_02').querySelector('.mod-newsList02').insertAdjacentHTML('beforeend', HTML02);
						 }
						 if(!HTML01) {
							document.querySelector('.js-newsList_2_01-li').classList.add('di_none');
							 document.querySelector('.js-newsList_2').querySelector('.js-newsList_2_01').classList.add('di_none');
						 } else {
							 document.querySelector('.js-newsList_2').querySelector('.js-newsList_2_01').querySelector('.mod-newsList02').insertAdjacentHTML('beforeend', HTML01);
						 }
						 document.querySelector('.js-newsList_2').classList.remove('di_none');
					} else {
						document.querySelector('.js-newsList_2-nolist').classList.remove('di_none');
					}
				});
			}
		}
	};

	slider();
	dropDown();
	newsList();


})(window.FUNCTIONS);
